import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { useAppSelector } from "../../../redux/hooks";

export const useCurrentUserProfile = () => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  return useQuery({
    queryKey: ["currentUserProfile", isAuthenticated],
    queryFn: async () => await apiClient.getUserProfile(),
    refetchOnWindowFocus: true,
    enabled: isAuthenticated,
  });
};
